import { useState as e, useEffect as i } from "react";
import { useFormik as o } from "../../node_modules/formik/dist/formik.esm.js";
import { DialogType as t } from "../../web/components/Dialog/types.js";
import s from "../../node_modules/lodash-es/pick.js";
import r from "../../node_modules/lodash-es/isEqual.js";
const a = ({ type: o2 }) => {
  const [s2, r2] = e(o2);
  i(() => {
    r2(o2);
  }, [o2]);
  const a2 = s2 === t.Create, m2 = s2 === t.Preview, n = s2 === t.Edit;
  return { formType: s2, setFormType: r2, isCreateMode: a2, isPreviewMode: m2, isEditMode: n };
}, m = ({ type: t2, defaultValues: m2, initialValues: n, initialErrors: l, validationSchema: d, onSubmit: p }) => {
  const u = a({ type: t2 }), [c, f] = e(false), y = o({ enableReinitialize: true, initialValues: n, initialErrors: l, validationSchema: d, validateOnChange: true, validateOnBlur: true, onSubmit: p }), { values: b } = y;
  return i(() => {
    const e2 = s(b, Object.keys(m2)), i2 = u.isCreateMode ? m2 : s(n, Object.keys(m2)), o2 = Object.keys(e2).some((o3) => !r(e2[o3], i2[o3]));
    f(o2);
  }, [m2, u.isCreateMode, n, b]), { isDirty: c, formik: y, formMode: u };
};
export {
  m as useForm,
  a as useFormMode
};
//# sourceMappingURL=useForm.js.map
